import * as constants from '../constants';
import { createSampleRow } from '../actions';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.createSampleRow.success: {
            return { ...action.payload, responseStatus: 'success' };
        }

        case constants.createSampleRow.error: {
            return { ...action.payload, responseStatus: 'error' };
        }

        case constants.createSampleRow.try: {
            return initialState;
        }

        default:
            return state;
    }
}